import SkapaElement from "@ingka/skapa-webc-element";
import { SlotTools } from "@ingka/webc-tools";
const styles = ':host([disabled]){--skapa-form-disabled:rgb(var(--colour-interactive-disabled-1,204,204,204));pointer-events:none}:host([disabled]) *,:host([disabled]) ::slotted(*){color:var(--skapa-form-disabled)}fieldset{border:0}fieldset,legend{margin:0;padding:0}legend{color:rgb(var(--colour-text-and-icon-1,17,17,17));font-weight:700}slot[name=helper-text]:not(.skapa-empty){display:block;padding-top:.5rem}slot[name=group-title]:not(.skapa-empty){display:block;padding-bottom:1rem}@media (forced-colors:active){:host([disabled]){--skapa-form-disabled:GrayText}}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <fieldset>
      <legend><slot name="group-title"></slot></legend>
      <slot id="main-slot"></slot>
      <slot name="helper-text"></slot>
    </fieldset>
  `;
  return { main: template };
}
const cacheAttributeName = "data-skapa-cache-disabled";
class Fieldset extends SkapaElement {
  constructor() {
    super();
    this.handleSlotChange = (ev) => {
      SlotTools.slotChange(ev);
      this.micro(this.syncState, "sync assigned elements state");
    };
    this.syncState = () => {
      const allAssignedElements = [
        this.embeddedFieldset,
        ...this.mainSlot.assignedElements({ flatten: true }).map((el) => [
          el,
          ...Array.from(
            el.querySelectorAll(
              `input, ${this.getPrefixedTagName("helper-text")}`
            )
          )
        ]).flat(2),
        ...this.helperSlot.assignedElements({ flatten: true })
      ];
      const syncDisableStateFunction = this.disabled ? disableAndCache : restoreCache;
      allAssignedElements.forEach((el) => {
        syncDisableStateFunction(el);
        el.toggleAttribute("subtle", this.subtle);
      });
    };
    this.gatherProperties(["subtle", "disabled"], this);
    const shadow = this.shadow = this.attachShadow({ mode: "open" });
    const templates = this.getTemplates(generateTemplate);
    shadow.append(templates.main.content.cloneNode(true));
    this.mainSlot = shadow.querySelector("#main-slot");
    this.helperSlot = shadow.querySelector(
      "slot[name=helper-text]"
    );
    this.embeddedFieldset = shadow.querySelector(
      "fieldset"
    );
  }
  static get observedAttributes() {
    return ["disabled"];
  }
  connectedCallback() {
    super.connectedCallback();
    Array.from(this.shadow.querySelectorAll("slot")).map(SlotTools.checkSlot);
    this.shadow.addEventListener("slotchange", this.handleSlotChange);
    this.syncState();
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (name === "disabled") {
      if (!(newVal === null) === !(oldVal === null))
        return;
      this.syncState();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadow.removeEventListener("slotchange", SlotTools.slotChange);
  }
  get subtle() {
    return this.hasAttribute("subtle");
  }
  set subtle(value) {
    this.toggleAttribute("subtle", !!value);
  }
  get disabled() {
    return this.hasAttribute("disabled");
  }
  set disabled(value) {
    this.toggleAttribute("disabled", !!value);
  }
}
Fieldset.skapaTagName = "fieldset";
Fieldset.skapaDependencies = [];
function disableAndCache(el) {
  if (el.hasAttribute("disabled"))
    return;
  el.toggleAttribute(cacheAttributeName, true);
  el.toggleAttribute("disabled", true);
}
function restoreCache(el) {
  if (el.hasAttribute(cacheAttributeName)) {
    el.removeAttribute("disabled");
    el.removeAttribute(cacheAttributeName);
  }
}
export {
  Fieldset
};
